const quote_before_login = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_QUOTE_BEFORE_LOGIN':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default quote_before_login;